"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "../ui";
import { useCallback } from "react";
import { RiAddLine, RiArrowDownSLine, RiCalendarLine, RiCheckboxCircleLine, RiGitBranchLine, RiMessageLine } from "react-icons/ri";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown";
import { useCarePlanContext } from "./care-plan";
import { useOptionalBranch } from "./decision/branch";
import { StepType } from "./types";
export function AddStepButton() {
  const $ = _c(23);
  const {
    actions: t0,
    config: t1
  } = useCarePlanContext();
  const {
    addStep,
    addBranchStep
  } = t0;
  const {
    readOnly
  } = t1;
  const branchCtx = useOptionalBranch();
  let t2;
  if ($[0] !== addBranchStep || $[1] !== addStep || $[2] !== branchCtx) {
    t2 = stepType => {
      if (branchCtx) {
        addBranchStep(branchCtx.branch.id, stepType);
      } else {
        addStep(stepType);
      }
    };
    $[0] = addBranchStep;
    $[1] = addStep;
    $[2] = branchCtx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onClick = t2;
  if (readOnly) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <RiAddLine size={16} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DropdownMenuTrigger asChild={true}><Button variant="secondary" size="sm" className="border-dashed text-nowrap" icon={t3}>Add Step<RiArrowDownSLine size={14} className="ml-1" /></Button></DropdownMenuTrigger>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <RiCalendarLine size={16} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onClick) {
    t6 = <DropdownMenuItem icon={t5} onClick={() => onClick(StepType.APPOINTMENT)}>Appointment</DropdownMenuItem>;
    $[7] = onClick;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <RiMessageLine size={16} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== onClick) {
    t8 = <DropdownMenuItem icon={t7} onClick={() => onClick(StepType.MESSAGE)}>Message</DropdownMenuItem>;
    $[10] = onClick;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <RiCheckboxCircleLine size={16} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== onClick) {
    t10 = <DropdownMenuItem icon={t9} onClick={() => onClick(StepType.TASK)}>Task</DropdownMenuItem>;
    $[13] = onClick;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <RiGitBranchLine size={16} />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== onClick) {
    t12 = <DropdownMenuItem icon={t11} onClick={() => onClick(StepType.DECISION)}>Decision</DropdownMenuItem>;
    $[16] = onClick;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12 || $[20] !== t6 || $[21] !== t8) {
    t13 = <DropdownMenu>{t4}<DropdownMenuContent align="start">{t6}{t8}{t10}{t12}</DropdownMenuContent></DropdownMenu>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t6;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}